export const METADATA_STRINGS = {
    VENDOR_STRING: 'Monochrome',
    DEFAULT_TITLE: 'Unknown Title',
    DEFAULT_ARTIST: 'Unknown Artist',
    DEFAULT_ALBUM: 'Unknown Album',
};
